import {find, isFunction, isNil, isObject, isString, merge} from 'lodash';
import WebViewer from '@pdftron/webviewer';

//const LICENSE_KEY = 'Vorenus Ventures LLC (mobilelocker.com):OEM:Mobile Locker::B+:AMS(20231211):D1A518DD04D7560AF360B13AC982537860616F5CA74095E076321BD45CF50EC664AA31F5C7';
//const LICENSE_KEY = 'Vorenus Ventures LLC:OEM:Mobile Locker::B+:AMS(20241211):C2A555AD04D7560A0360B13AC982537867616F5CA74095E076321BD45CF50EC664AA31F5C7';
//const LICENSE_KEY = 'Vorenus Ventures LLC:OEM:Mobile Locker::B+:AMS(20241211):C1A558DD04D7560A0360B13AC982537860616F5CA74095E076321BD45CF50EC664AA31F5C7';
const LICENSE_KEY = 'Vorenus Ventures LLC:OEM:Mobile Locker::B+:AMS(20271211):95A515FD04D7560AC360B13AC982527860616F5CA74095E076321BD45CF50EC664AA31F5C7';

/**
 * MLD-917
 */
export default {
  getLicenseKey() {
    return LICENSE_KEY;
  },
  /**
   * @param {Object} header
   * @param {string} dataElement
   * @returns {Object|null}
   */
  getHeaderObjectByDataElement(header, dataElement) {
    return find(header.getItems(), item => item.dataElement === dataElement);
  },
  /**
   *
   * @param {Object} header
   * @param {string} className
   * @returns {Object|null}
   */
  getHeaderObjectByClassName(header, className) {
    return find(header.getItems(), item => item.className === className);
  },
  getWebViewerServerURL() { // MLD-3580
    if (isObject(window.config) && isString(window.config.pdfURL)) {
      return window.config.pdfURL
    } else if (isObject(window.ML) && isString(window.ML.pdfURL)) {
      return window.ML.pdfURL;
    }
    return 'https://pdf.mobilelocker.com';
  },
  /**
   * @see https://docs.apryse.com/web/guides/modular-ui/containers
   * @param {WebViewerInstance} instance
   * @param {Object} presentation
   * @param {Boolean} viewerMode
   * @param {Function|null} changePageCallback
   * @param {Function|null} downloadCallback
   * @param {Function|null} printCallback
   * @returns {Promise<void>}
   */
  async configureUI(instance, presentation, viewerMode, changePageCallback, downloadCallback, printCallback) {
    console.log('[PDF] Configuring UI...');
    const {UI, Core} = instance;
    const {documentViewer, Tools} = Core;

    console.log('[PDF] Setting header...');
    // @see https://sdk.apryse.com/api/web/UI.html#.PRESET_BUTTON_TYPES
    const topHeader = instance.UI.getModularHeader('default-top-header')
    //console.log('PDFTron: topHeader.getGroupedItems()', topHeader.getGroupedItems());
    const groupedLeftHeaderButtons = topHeader.getGroupedItems()[0];
    groupedLeftHeaderButtons.setItems([
      groupedLeftHeaderButtons.items[2], // Left Panel Button
      groupedLeftHeaderButtons.items[3], // View Controls
      groupedLeftHeaderButtons.items[4], // Divider
      groupedLeftHeaderButtons.items[5], // Zoom Controls
      groupedLeftHeaderButtons.items[6], // Divider
      new UI.Components.PresetButton({buttonType: UI.PRESET_BUTTON_TYPES.FULLSCREEN}),
      groupedLeftHeaderButtons.items[7], // PAN Button
      new UI.Components.Divider({dataElement: 'left_div1'}),
    ]);

    const downloadButton = new UI.Components.CustomButton({
      dataElement: 'downloadButton',
      className: 'ML_Button ML_Button--Download',
      title: 'Download',
      onClick: () => {
        //console.log('Download button clicked!');

        // 3. Download the file
        if (presentation) {
          const filename = `${presentation.slug}.pdf`;
          if (['DWG', 'DXF'].includes(presentation.presentation_type)) {
            // MLD-3044 We need to let the viewer download the original CAD file instead of the PDF Rendition
            let link = document.createElement('a');
            link.href = presentation.signedURL;
            link.download = filename;
            link.dispatchEvent(new MouseEvent(`click`, {bubbles: true, cancelable: true, view: window}));
          } else if (presentation.presentation_type === 'Image') {
            // MLD-3106 we need to let the viewer download the original Image file instead of the PDF Rendition
            let link = document.createElement('a');
            link.href = presentation.signedURL;
            link.download = filename;
            link.dispatchEvent(new MouseEvent(`click`, {bubbles: true, cancelable: true, view: window}));
          } else if (presentation.presentation_type === 'Illustrator') { // MLD-5165
            let link = document.createElement('a');
            link.href = presentation.signedURL;
            link.download = filename;
            link.dispatchEvent(new MouseEvent(`click`, {bubbles: true, cancelable: true, view: window}));
          }/* else if (this.canDownloadMicrosoftFile) {
            // MLD-4124 we need to let the viewer download the original PowerPoint, Excel, or Word file instead of the PDF rendition
            let link = document.createElement('a');
            link.href = presentation.signedURL;
            link.dispatchEvent(new MouseEvent(`click`, {bubbles: true, cancelable: true, view: window}));
          }*/ else {
            // 3. Download the file, including any fields that were filled in
            // MLD-2332
            // @see https://www.pdftron.com/documentation/web/guides/forms/flatten-forms/
            // @see https://www.pdftron.com/api/web/WebViewerInstance.html#downloadPdf__anchor
            instance.UI.downloadPdf({
              filename: `${presentation.slug}.pdf`,
              flatten: false,
              includeAnnotations: true,
              flags: Core.SaveOptions.LINEARIZED,
            })
          }
        }

        if (isFunction(downloadCallback)) {
          downloadCallback();
        }
      },
      img: 'icon-download',
    });

    //const printButton = new UI.Components.PresetButton({buttonType: UI.PRESET_BUTTON_TYPES.PRINT});
    // @see https://docs.apryse.com/web/guides/print/overview
    const printButton = new UI.Components.CustomButton({
      dataElement: 'printButton',
      className: 'ML_Button ML_Button--Print',
      title: 'Print this file',
      onClick: () => {
        instance.UI.print();
        if (isFunction(printCallback)) {
          printCallback();
        }
      },
      img: 'icon-header-print-line',
    })

    const previousPageButton = new UI.Components.CustomButton({
      dataElement: 'previousPageButton',
      title: 'Go to the previous page',
      onClick: () => {
        const currentPage = documentViewer.getCurrentPage();
        if (currentPage > 1) {
          documentViewer.setCurrentPage(currentPage - 1, false);
          if (isFunction(changePageCallback)) {
            changePageCallback();
          }
        }
      },
      img: 'icon-arrow-left',
    });
    const nextPageButton = new UI.Components.CustomButton({
      dataElement: 'nextPageButton',
      title: 'Go to the next page',
      onClick: () => {
        const pageCount = documentViewer.getPageCount();
        const currentPage = documentViewer.getCurrentPage();
        if (currentPage < pageCount) {
          documentViewer.setCurrentPage(currentPage + 1, false);
          if (isFunction(changePageCallback)) {
            changePageCallback();
          }
        }
      },
      img: 'icon-arrow-right',
    });

    const groupedRightHeaderItems = [];

    if (isObject(presentation?.settings)) {
      if (viewerMode) {
        if (presentation.settings.can_be_printed || presentation?.settings.can_be_downloaded) {
          groupedRightHeaderItems.push(new UI.Components.Divider({dataElement: 'right_div1'}));
          if (presentation.settings.can_be_printed) {
            groupedRightHeaderItems.push(printButton);
          }
          if (presentation.settings.can_be_downloaded) {
            groupedRightHeaderItems.push(downloadButton);
          }
        }
      } else {
        if (presentation.settings.can_be_printed_by_user || presentation?.settings.can_be_exported) {
          groupedRightHeaderItems.push(new UI.Components.Divider({dataElement: 'right_div1'}));
          if (presentation.settings.can_be_printed_by_user) {
            groupedRightHeaderItems.push(printButton);
          }
          if (presentation.settings.can_be_exported) {
            groupedRightHeaderItems.push(downloadButton);
          }
        }
      }
    }
    groupedRightHeaderItems.push(new UI.Components.Divider({dataElement: 'right_div2'}));
    groupedRightHeaderItems.push(previousPageButton);
    groupedRightHeaderItems.push(nextPageButton);
    const groupedRightHeaderButtons = new UI.Components.GroupedItems({
      alwaysVisible: true,
      dataElement: 'groupRightHeaderButtons',
      grow: 0,
      gap: 12,
      position: 'end',
      items: groupedRightHeaderItems,
    });
    topHeader.setItems([
      groupedLeftHeaderButtons,
      groupedRightHeaderButtons,
    ]);
    console.log('[PDF] Setting header... done');

    console.log('[PDF] Setting panels...');
    // Changing items in a panel
    // @see https://docs.apryse.com/web/guides/modular-ui/panels#changing-items-in-a-tab-panel
    const allPanels = instance.UI.getPanels();
    const panelNames = [
      'searchPanel',
      'tabPanel',
      'thumbnailsPanel',
    ];
    const panels = [];
    allPanels.forEach(panel => {
      //console.log('PDFTron: Existing Panel', panel.dataElement, panel);
      if (panelNames.includes(panel.dataElement)) {
        panels.push(panel);
        //console.log('PDFTron: Including panel', panel.dataElement);
      } else {
        //console.log('PDFTron: Excluding panel', panel.dataElement);
      }
    })
    //console.log('PDFTron: Setting panels', panels);
    instance.UI.setPanels(panels);
    console.log('[PDF] Setting panels... done');

    // @see https://docs.apryse.com/web/guides/zoom
    // @see https://sdk.apryse.com/api/web/UI.html?_gl=1*tyww1p*_gcl_au*OTY4MTE3MzE1LjE3NTE0NjM1NDg.#.getMinZoomLevel
    console.log('[PDF] Setting zoom levels...');
    //instance.UI.setMinZoomLevel('25%');
    // @see https://sdk.apryse.com/api/web/UI.html?_gl=1*tyww1p*_gcl_au*OTY4MTE3MzE1LjE3NTE0NjM1NDg.#.setMaxZoomLevel
    //instance.UI.setMaxZoomLevel(4);
    console.log('[PDF] Setting zoom levels... done');

    console.log('[PDF] Disabling elements...');
    instance.UI.disableElements([
      // Thumbnail Panel
      'thumbRotateClockwise',
      'thumbDelete',
      'pageManipulationOverlayButton',
      'documentControl',
      // Page Manipulation Flyout
      'pageManipulationFlyout',
      'moveToTop',
      'moveToBottom',
      'rotatePageClockwise',
      'rotatePageCounterClockwise',
      'insertPage',
      'replacePage',
      'extractPage',
      'deletePage',
      // Left Panel
      /*'outlinesPanel-tabPanel',
      'bookmarksPanel-tabPanel',
      'layersPanel-tabPanel',
      'tabPanel-moreButton',*/
      // View Controls
      'rotateClockwiseButton',
      'rotateCounterClockwiseButton',
      //'fullscreenButton',
      // Context Panel
      'contextMenuPopup',
      // MLD-8109
      'linkAnnotationPopup',
    ])
    console.log('[PDF] Disabling elements... done');

    // Set the modular header in the UI
    //instance.UI.setModularHeaders([topHeader]);
    console.log('[PDF] Configuring UI... done');
  },
  /**
   * MLD-7711
   * @see https://docs.apryse.com/web/guides/web-component-vs-iframe#webviewer-as-a-web-component
   * @param url
   * @param viewerElement
   * @param options
   * @returns {Promise<WebViewerInstance>}
   * @deprecated MLD-8109
   */
  async createWebComponent(url, viewerElement, options = {}) {
    const config = {
      //css: '/webviewer.css',
      disableLogs: false, // Disables console logs coming from WebViewer, including the version and build numbers
      forceClientSideInit: true, // If set to true then when loading a document using WebViewer Server the document will always switch to client only rendering allowing page manipulation and the full API to be used.
      fullAPI: true, // Enable PDFNet.js library functions
      initialDoc: url,
      licenseKey: this.getLicenseKey(),
      path: '/v2/js/WebViewer',
      webviewerServerURL: this.getWebViewerServerURL(),
      //preloadWorker: 'pdf', // Type of workers to be preloaded. Accepts `pdf`|`office`|`legacyOffice`|`all`. You can also include multiple types comma separated e.g. `pdf,office`
    }
    merge(config, options);
    return await WebViewer(config, viewerElement);
  },
  /**
   * MLD-8050 This function initializes the viewer without fullAPI and webviewerServerURL.
   * Acertis Presentation 33433 needs this.
   * @see https://support.apryse.com/support/tickets/131743
   * @param url
   * @param viewerElement
   * @param options
   */
  async createClientViewer(url, viewerElement, options = {}) {
    // @see WebViewerOptions https://www.pdftron.com/api/web/global.html#WebViewerOptions__anchor
    const config = {
      //annotationUser: null,
      css: '/webviewer.css',
      // https://www.pdftron.com/documentation/web/guides/hiding-elements#list-of-elements
      disabledElements: [
        //'leftPanelButton',
        //'viewControlsButton', // MLD-2880
        //'viewControlsOverlay', // MLD-2880
        'panToolButton',
        'selectToolButton',
        'fitButton',
        //'zoomOutButton',
        //'zoomInButton',
        //'zoomOverlayButton',
        'toolsButton',
        //'searchButton',
        //'searchOverlay',
        'menuButton',
        'menuOverlay',
        'filePickerButton',
        //'printButton',
        //'download',
        //'downloadButton',
        'toolsOverlay',
        // MLD-2249 @see https://www.pdftron.com/documentation/web/guides/customizing-header/#customizing-ribbons
        'pageNavOverlay',
        'ribbons',
        'toolbarGroup-Shapes',
        'toolbarGroup-Edit',
        'toolbarGroup-Insert',
      ],
      disableLogs: false, // Disables console logs coming from WebViewer, including the version and build numbers
      //enableAnnotations: false, // Enable annotations feature (default is TRUE)
      //extension: 'pdf',
      forceClientSideInit: true, // If set to true then when loading a document using WebViewer Server the document will always switch to client only rendering allowing page manipulation and the full API to be used.
      //fullAPI: true,  // MLD-8050 We need this off for Presentation 33433
      initialDoc: url, // URL path to a document to load on startup
      //isAdminUser: false,
      //isReadOnly: true,
      licenseKey: this.getLicenseKey(), // License key for viewing documents. If not set then WebViewer will be in demo mode.
      path: '/v2/js/WebViewer', // Path to the WebViewer lib folder
      //webviewerServerURL: this.getWebViewerServerURL(), // MLD-8050 We need this off for Presentation 33433
      preloadWorker: 'pdf', // Type of workers to be preloaded. Accepts `pdf`|`office`|`legacyOffice`|`all`. You can also include multiple types comma separated e.g. `pdf,office`
      ui: 'legacy', // MLD-6881
    };
    merge(config, options);
    return await WebViewer.Iframe(config, viewerElement); // @see https://www.pdftron.com/documentation/web/guides/integrate
  },
  getCdnPath() { // MLD-8081
    /*if (isObject(window.config) && isObject(window.config.cdn) && isString(window.config.cdn.url) && window.config.cdn.enabled) {
      return window.config.cdn.url;
    } else if (isObject(window.ML) && isObject(window.ML.cdn) && isString(window.ML.cdn.url) && window.ML.cdn.enabled) {
      return window.ML.cdn.url;
    } else {
      return '';
    }*/
    return '';
  },
  getCSSPath() {
    return `${this.getCdnPath()}/webviewer.css`;
  },
  getWebViewerPath() { // MLD-8081
    return `${this.getCdnPath()}/v2/js/WebViewer`;
  },
  /**
   * @param {object} presentation
   * @param {string} url
   * @returns {object}
   */
  buildConfigForPresentation(presentation, url) { // MLD-8109
    if (isObject(presentation) === false) {
      throw new Error('[PDF] Invalid presentation object.');
    }
    if (isObject(presentation.settings) === false) {
      throw new Error('[PDF] Invalid presentation.settings object.');
    }
    const useFullAPI = presentation.settings?.pdf_use_full_api ?? true;
    const useWebViewerServer = presentation.settings?.pdf_use_webviewer_server ?? false;
    const webviewerServerURL = useWebViewerServer ? this.getWebViewerServerURL() : null;
    const options = {
      initialDoc: url,
    }
    if (useFullAPI) {
      options.fullAPI = useFullAPI;
    }
    if (useWebViewerServer) {
      options.webviewerServerURL = webviewerServerURL;
    }
    console.log('[PDF] Using Full API:', useFullAPI);
    console.log('[PDF] Using WebViewer server:', useWebViewerServer);
    console.log('[PDF] WebViewer server URL:', this.getWebViewerServerURL());
    console.log('[PDF] Options:', options);
    return options;
  },
  /**
   * @see WebViewerOptions https://www.pdftron.com/api/web/global.html#WebViewerOptions__anchor
   * @param {string} url
   * @param {object} options
   * @param {boolean} legacyMode
   */
  buildFinalConfig(url, options = {}, legacyMode) {
    const config = {
      css: this.getCSSPath(),
      disableLogs: false, // Disables console logs coming from WebViewer, including the version and build numbers
      initialDoc: url, // URL path to a document to load on startup
      licenseKey: this.getLicenseKey(), // License key for viewing documents. If not set then WebViewer will be in demo mode.
      path: this.getWebViewerPath(), // Path to the WebViewer lib folder
    };
    if (legacyMode) { // MLD-8109
      // https://www.pdftron.com/documentation/web/guides/hiding-elements#list-of-elements
      config.disabledElements = [
        'panToolButton',
        'selectToolButton',
        'fitButton',
        'toolsButton',
        'menuButton',
        'menuOverlay',
        'filePickerButton',
        'toolsOverlay',
        'pageNavOverlay',
        'ribbons',
        'toolbarGroup-Shapes',
        'toolbarGroup-Edit',
        'toolbarGroup-Insert',
        'linkAnnotationPopup',
        'toolsHeader',
      ],
        config.ui = 'legacy';
    }
    const finalConfig = {};
    merge(finalConfig, config, options);
    console.log('[PDF] Final config', finalConfig);
    return finalConfig
  },
  /**
   *
   * @param url
   * @param viewerElement
   * @param options
   * @param presentationID
   * @return Promise
   */
  async createViewer(url, viewerElement, options = {}, presentationID = null) {
    const finalConfig = this.buildFinalConfig(url, options);
    console.log('[PDF] Final config', finalConfig);
    const instance = await WebViewer.Iframe(finalConfig, viewerElement);
    await this.initializeFullAPI(finalConfig, instance);
    return instance;
  },
  async initializeFullAPI(finalConfig, instance) {
    if (finalConfig.fullAPI) {
      // MLD-5350
      // @see https://docs.apryse.com/web/guides/full-api-overview
      // @see https://support.apryse.com/support/tickets/62048
      try {
        console.log('[PDF] Initializing PDFNet...');
        const {PDFNet} = instance.Core;
        await PDFNet.initialize(this.getLicenseKey());
        console.log('[PDF] Initializing PDFNet... done');
      } catch (error) {
        console.error('[PDF] PDFNet initialization failed', error.message);
      }
    }
  },
  startSession(hitUUID) {
    const now = new Date();
    console.log(`${now} - hit ${hitUUID} - startSession()`);
  },
  endSession(hitUUID) {
    const now = new Date();
    console.log(`${now} - hit ${hitUUID} - endSession()`);
  },
  logEvent(hitUUID, pageNumber) {
    const now = new Date();
    console.log(`${now} - hit ${hitUUID} - page ${pageNumber}`);
  },
  async configureVideoAnnotations(instance) { // MLD-5350
    if (isNil(instance.Core.PDFNet)) {
      console.log('[PDF] PDFTron: PDFNet is not available. Skipping video annotations configuration.');
      return;
    }
    console.log('[PDF] PDFTron: Configuring video annotations...');
    // MLD-5350
    const {PDFNet, documentViewer, annotationManager, Annotations} = instance.Core;

    const VideoAnnotation = function (videoBlob, rect) {
      Annotations.HTMLAnnotation.call(this, {rect});
      this.Subject = 'Video';
      this.videoBlob = videoBlob;
    };

    VideoAnnotation.prototype = new Annotations.HTMLAnnotation();
    VideoAnnotation.prototype.elementName = 'video';

    VideoAnnotation.prototype.createInnerElement = function () {
      const videoElement = document.createElement('video');
      videoElement.src = window.URL.createObjectURL(this.videoBlob);
      videoElement.controls = true;
      videoElement.playsinline = true;
      return videoElement;
    };

    VideoAnnotation.prototype.serialize = function () {
    };

    // @see https://docs.apryse.com/api/web/Core.DocumentViewer.html#.Events__anchor
    const DocumentViewerEvents = instance.Core.DocumentViewer.Events;

    documentViewer.addEventListener(DocumentViewerEvents.ANNOTATIONS_LOADED, async () => {
      //console.log(`PDFTron: Annotations Loaded.`);
      //await PDFNet.initialize();
      const pdfDocument = await documentViewer.getDocument().getPDFDoc();

      for (let i = 1; i <= documentViewer.getDocument().getPageCount(); i++) {
        const page = await pdfDocument.getPage(i);
        //console.log(`PDFTron: Looking for rich media annotations on page ${i}`, page)

        const numberOfAnnotations = await page.getNumAnnots();
        //console.log(`PDFTron: Page ${i} has ${numberOfAnnotations} annotations`)

        for (let j = 0; j < numberOfAnnotations; j++) {
          const annotation = await page.getAnnot(j);
          if (!(await annotation.isValid())) {
            //console.log(`PDFTron: Annotation ${j} on page ${i} is not valid.`)
            continue;
          }
          const type = await annotation.getType();

          if (PDFNet.Annot.Type.e_RichMedia === type) {
            const annotationObject = await annotation.getSDFObj();
            const richMediaContentObject = await annotationObject.findObj("RichMediaContent");

            if (richMediaContentObject) {
              //console.log(`PDFTron: RichMediaContent annotation found on page ${i} at position ${j}.`);
              const assets = await (PDFNet.NameTree.createFromObj(await richMediaContentObject.findObj("Assets")));
              if (await assets.isValid()) {
                //console.log(`PDFTron: RichMediaContent annotation on page ${i} at position ${j} has valid assets.`);
                try {
                  let iterator = await assets.getIteratorBegin();
                  for (; await iterator.hasNext(); await iterator.next()) {
                    const file_spec = await PDFNet.FileSpec.createFromObj(await iterator.value());

                    const stream = await file_spec.getFileData();
                    if (stream) {
                      const filterReader = await PDFNet.FilterReader.create(stream)
                      const arrayBuffer = await filterReader.readAllIntoBuffer();
                      const blob = new Blob([arrayBuffer], {type: 'video/mp4'});

                      const pageNumber = await (await annotation.getPage()).getIndex();
                      const pdfCoords = await annotation.getRect();
                      const document = documentViewer.getDocument();

                      const viewerBottomLeftCornerCoords = document.getViewerCoordinates(pageNumber, pdfCoords.x1, pdfCoords.y1);
                      const viewerTopRightCornerCoords = document.getViewerCoordinates(pageNumber, pdfCoords.x2, pdfCoords.y2);

                      const rect = new Annotations.Rect(viewerBottomLeftCornerCoords.x, viewerTopRightCornerCoords.y, viewerTopRightCornerCoords.x, viewerBottomLeftCornerCoords.y);
                      const videoAnnotation = new VideoAnnotation(blob, rect);

                      videoAnnotation.PageNumber = pageNumber;
                      annotationManager.addAnnotation(videoAnnotation);
                      annotationManager.drawAnnotations({pageNumber: videoAnnotation.PageNumber, majorRedraw: true}).then().catch(() => {
                      })
                      //console.log(`PDFTron: Added video annotation to page ${pageNumber}`)
                    } else {
                      console.log(`PDFTron: stream missing.`);
                    }
                  }
                } catch (e) {
                  console.log(`PDFTron: There was a problem with the iterator`, e.message);
                }
              } else {
                console.log(`PDFTron: assets are not valid.`);
              }
            } else {
              console.log(`PDFTron: RichMediaContent annotation not found.`);
            }
          } else {
            // console.log(`PDFTron: Annotation ${j} on page ${i} is not rich media. It is ${type}.`);
          }
        }
      }
    });

    console.log('[PDF] PDFTron: Video annotations configuration... done.');
  }
}
